import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { validationmethod } from 'src/app/shared/models/validationmethod';
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';


export interface createRecordPopupEditData {
  editData: any; 
  editRowData:any;
}

@Component({
    selector: 'app-create-records-popup',
    templateUrl: './create-records-popup.component.html',
    styleUrls: ['./create-records-popup.component.scss'],
    standalone: false
})
export class CreateRecordsPopupComponent implements OnInit {

 buttonColor = "";
  backgroundColorScreen;
  dynamicForm: FormGroup = new FormGroup({});
  headersData;
  fields=[];
  recordList=[]
  buttonName="Add"
  updateExistingRecord;
  constructor(private validation: validationmethod,
    private localStorageSettings: LocalStorageSettingsService,
    public dialogref: MatDialogRef<CreateRecordsPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data:createRecordPopupEditData
  ) { }

  ngOnInit(): void {
    this.fields=[]
    this.headersData =this.data.editData;
    console.log(this.headersData);
    console.log(this.data.editRowData);
    
    let sourceFields=this.headersData.SourceColumns.map(col =>  ({
    label: col.label,
    datatype: col.datatype,
    isMandatory: col.isMandatory
  }));
    let targetFields=this.headersData.TargetColumns.map(col => ({
    label: col.label,
    datatype: col.datatype,
    isMandatory: col.isMandatory
  }));
    this.fields.push(...sourceFields);
    this.fields.push(...targetFields)
    console.log(this.fields);
    console.log(targetFields);

     this.fields.forEach(field => {
      const validators = [];
      const datatype = field.datatype.toLowerCase();

  if (field.isMandatory) {
    validators.push(Validators.required);
  }

  if (datatype === 'integer') {
    validators.push(Validators.pattern(/^-?\d+$/)); 
  }
  this.dynamicForm.addControl(field.label, new FormControl('', validators));
    });
  if(this.data.editRowData){
    this.updateExistingRecord=this.data.editRowData
    this.dynamicForm.patchValue(this.data.editRowData);
    this.buttonName="Update"
  }
    this.backgroundColorScreen = this.localStorageSettings.getSettings("ColorD");
    this.buttonColor = this.localStorageSettings.getSettings("ColorA");

  }

  getInputType(datatype: string): string {
  if (!datatype) return 'text';
  switch (datatype.toLowerCase()) {
    case 'integer':
      return 'number';
    case 'boolean':
      return 'text';
    default:
      return 'text';
  }
}
  addWhere(){
     if (this.dynamicForm.invalid) {
    this.dynamicForm.markAllAsTouched();
    return; 
  }
    this.recordList.push(this.dynamicForm.value)
    console.log(this.dynamicForm.value)
    this.dynamicForm.reset();
    console.log(this.recordList);
    
  }
  deleteWhere(k) {
    console.log(k)
    this.recordList.splice(k, 1);
  }
  saveHeaders(){
    if(this.buttonName == 'Add'){
      this.dialogref.close(this.recordList);
    }else{
      let object=this.dynamicForm.value;
      object.index = this.updateExistingRecord.index
      console.log(this.dynamicForm.value);
      console.log(object);
      this.dialogref.close(object);
    }
    
  }
  cancel(){
    this.dialogref.close();
  }
}
